import Box from '@mui/material/Box'
import Typography from '@mui/material/Typography'

export const CloudText = ({ title }) => {
    return (
        <Box
            sx={{
                mt: 4,
                position: 'relative',
                background: '#F3F3F3',
                color: '#000',
                padding: '10px 18px',
                borderRadius: '24px',
                textAlign: 'center',
                '&:after': {
                    border: '19px solid transparent',
                    borderTopColor: '#F3F3F3',
                    position: 'absolute',
                    top: '100%',
                    left: '26px',
                    content: "''",
                    zIndex: 1002,
                },
            }}>
            <Typography
                variant="h4"
                textAlign="center"
                sx={{
                    borderRadius: '24px',
                }}>
                {title}
            </Typography>
        </Box>
    )
}
